/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTabTwo.vue?vue&type=template&id=36a1f438"
import script from "./mTabTwo.vue?vue&type=script&lang=js"
export * from "./mTabTwo.vue?vue&type=script&lang=js"
import style0 from "./mTabTwo.vue?vue&type=style&index=0&id=36a1f438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports